import { ApiResponse } from '@/shared/types';
import { useMutation } from '@tanstack/react-query';
import { infrastructuresRepo } from '@/constants/providers';

export const useDisableInfrastructureCost = () =>
  useMutation<ApiResponse<unknown>, unknown, number>((id) =>
    infrastructuresRepo.disableInfrastructureCost(id),
  );
